import {
  FETCH_TICKET_QUEUE_LIST,
  CREATE_TICKET_QUEUE,
  UPDATE_TICKET_QUEUE,
} from "./types";

export const fetchTicketQueues = (payload: any) => {
  return {
    type: FETCH_TICKET_QUEUE_LIST,
    payload,
  };
};

export const createTicketQueue = (payload: any) => {
  return {
    type: CREATE_TICKET_QUEUE,
    payload,
  };
};

export const updateTicketQueue = (payload: any) => {
  return {
    type: UPDATE_TICKET_QUEUE,
    payload,
  };
};
